import React from 'react';
import Grid2 from "@mui/material/Grid2";
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import {useSxStyles as sx} from "../styles/sxStyles";

const TandC = () => {
    return (
        (<Grid2 container spacing={1} sx={sx.text}>
            < Grid2 sx={sx.gridTandC} size={12}>
                <Typography variant='h6' sx={sx.textTandC}>
                    {'Terms & Conditions'}
                </Typography>
            </Grid2>
            < Grid2 style={{paddingTop: "1rem"}} size={12}>
                By using this web site, you accept these terms and conditions. Please read them carefully.
                In order to use the services offered on this web site, you must obtain access to the World
                Wide Web, either directly or through devices that access web-based content, and pay any
                service fees associated with such access. In addition, you must provide all equipment
                necessary to make such connection to the World Wide Web, including a computer and modem
                or other access device.
            </Grid2>
            < Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Privacy Policy:</Typography> By using the
                NEUMO payments site you agree to the privacy statement located at <Link href="https://www.citepayusa.com" />.
            </Grid2>
            < Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Misuse or Fraud:</Typography> Justice
                Systems, Inc. has the right to refuse service, terminate user access
                or cancel transactions at any time at the sole discretion of Justice Systems,
                Inc. Justice Systems, Inc. also has the right to hold funds pending an investigation of fraud or misuse of this web site.
            </Grid2>
            < Grid2 size={12} >
                <Typography component='div' sx={sx.bold}>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY:</Typography>
                THIS SITE IS PROVIDED BY JUSTICE SYSTEMS, INC. ON AN “AS IS” AND “AS AVAILABLE” BASIS. JUSTICE SYSTEMS, INC.
                MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THIS SITE OR
                THE INFORMATION, CONTENT MATERIALS, PRODUCTS OR SERVICES INCLUDED ON THIS SITE. YOU EXPRESSLY AGREE THAT YOUR
                USE OF THIS SITE IS AT YOUR SOLE RISK AND THAT YOU ARE SOLELY RESPONSIBLE FOR THE ACCURACY OF THE PERSONAL AND
                PAYMENT INFORMATION THAT YOU PROVIDE.
            </Grid2>
            < Grid2 size={12} >
                TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, JUSTICE SYSTEMS, INC. DISCLAIMS ALL WARRANTIES, EXPRESS OR
                IMPLIED, INCLUDING, BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
                JUSTICE SYSTEMS, INC. DOES NOT WARRANT THAT THIS SITE, ITS SERVICES OR E-MAIL SENT FROM JUSTICE SYSTEMS, INC. ARE
                FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. JUSTICE SYSTEMS, INC. (AS WELL AS ITS MANAGERS, OFFICERS, DIRECTORS,
                EMPLOYEES, AFFILIATES AND SHAREHOLDERS) WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THIS
                SITE, ANY CREDIT CARD COMPANY'S NON-AUTHORIZATION OF A USER'S CREDIT CARD PAYMENT, ANY GOVERNMENT ENTITY'S NON-ACCEPTANCE
                OF A PAYMENT FROM A PARTY USING THIS SITE OR FOR DISRUPTIONS IN SERVICE ON THIS SITE, REGARDLESS OF THE CAUSE, INCLUDING
                (WITHOUT LIMITATION) DIRECT, INDIRECT, INCIDENTAL, PUNITIVE AND CONSEQUENTIAL DAMAGES. JUSTICE SYSTEMS, INC. ASSUMES NO
                RESPONSIBILITY FOR THE TIMELINESS, DELETION, MIS-DELIVERY OR FAILURE TO STORE ANY USER COMMUNICATIONS OR PERSONALIZATION SETTINGS.
            </Grid2>
            < Grid2 size={12} >
                CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
                THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU
                MIGHT HAVE ADDITIONAL RIGHTS.
            </Grid2>
            < Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Applicable Law:</Typography> By visiting this web site, you
                agree that the laws of the State of Indiana, without regard to its principles of conflict of laws, will govern
                these terms and conditions and any dispute of any kind that may arise between you and Justice Systems, Inc.
            </Grid2>
            < Grid2 size={12} >
                <Typography component='span' sx={sx.bold}>Other Legal Terms and Conditions:</Typography> Completion
                of a payment transaction is contingent upon both the authorization of payment by the applicable card company and
                acceptance of your payment by the relevant governmental authority or other entry you are attempting to pay. In the
                event your payment is not processed or authorized by your card company or the applicable governmental authority or
                other entity you are seeking to pay fails to accept your payment your payment liability shall remain outstanding
                and unpaid and you will be subject to penalties, late fees and interest charges assessed by the relevant entity
                thereon. You may be responsible for fees and administrative costs related to payments you dispute and imposed by
                the governmental authority and or Justice Systems, Inc. All or any of these obligations remain your sole responsibility.
            </Grid2>
            <Grid2 size={12} >
                Justice Systems, inc. reserves the right to make changes to this web site (including, without limitation, discontinuing
                this web site or the services offered on this site) and these terms and conditions at any time, with or without notice.
            </Grid2>
            <Grid2 size={12} >
                If any of these terms and conditions shall be deemed invalid, void of for any reason unenforceable, that term or
                condition shall be deemed severable and shall not affect the validity and enforceability of any remaining terms or conditions.
            </Grid2>
            <Grid2 size={12} >
                Use of any of the information on this web site, including without limitation the e-mail addresses that are posted here, to
                transmit, distribute or facilitate the distribution of unsolicited bulk e-mail or other such advertisements or solicitations
                to Justice Systems, Inc. or any of its employees or agents; and, any such use of the information on this site is a violation
                of these terms and conditions.
            </Grid2>
        </Grid2>)
    );
};

export default TandC;